import { ComponentProps, ComponentType, JSX, PureComponent } from "react";

import { SvgConstantDarkModePositiveTheme } from "../SvgConstants";
import { InjectedSvgProps } from "./hocTypings";
import { getDisplayName } from "./utils";

export function asDarkModePositiveSvg<
  C extends ComponentType<ComponentProps<C> & InjectedSvgProps>,
  ResolvedProps = JSX.LibraryManagedAttributes<C, ComponentProps<C>>
>(WrappedComponent: C) {
  return class AsDarkModePositiveSvg extends PureComponent<
    ResolvedProps & InjectedSvgProps
  > {
    static displayName = `asDarkModePositiveSvg(${getDisplayName(
      WrappedComponent
    )})`;

    static defaultProps = {
      fillColor: SvgConstantDarkModePositiveTheme.fill,
      secondaryFillColor: SvgConstantDarkModePositiveTheme.secondaryFill,
      className: "ddbc-svg--positive",
    };

    render() {
      return <WrappedComponent {...(this.props as any)} />;
    }
  };
}
